class UpdateAlumniService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {
            formConfig: {},
            data: {},
            routeInfo: params,
            internal: { gridState: {} },
        };
        return Promise.resolve(state);
    }
}

export default UpdateAlumniService;
